import { type FC, useRef } from "react";
import { useOverlayTrigger } from "react-aria";
import { useOverlayTriggerState } from "react-stately";
import { DialogComponent, Popover, VStack } from "widgets";
import { useResizeObserver } from "widgets/hooks";

import { Tile, type TileProps } from "@/modules/core/components/Tile.tsx";

export const StackTile: FC<TileProps> = ({ children, ...props }) => {
  const triggerRef = useRef<HTMLDivElement>(null);
  const state = useOverlayTriggerState({});
  const { overlayProps } = useOverlayTrigger({ type: "dialog" }, state, triggerRef);

  const rect = useResizeObserver(triggerRef);

  return (
    <>
      <Tile
        onPress={() => {
          state.open();
        }}
        ref={triggerRef}
        {...props}
      />
      <Popover state={state} triggerRef={triggerRef} {...overlayProps}>
        <DialogComponent
          title={props.title}
          subtitle={props.type}
          closeFn={state.close}
          width={(rect?.width ?? 470) + 10}
          actions={props.menuButton ? [props.menuButton] : undefined}
        >
          <VStack>{children}</VStack>
        </DialogComponent>
      </Popover>
    </>
  );
};
